<template>
    <div>
        <kgr-alert sticky />

        <label class="kgr-inputGroup">
            <div class="kgr-inputGroup__label">{{ tListActionSelectLabel }}</div>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--small-stacked">
                <div class="kgr-postfix__fixed">
                    <kgr-dropdown
                        id="list-action-select"
                        v-model="action"
                        display="label"
                        :options="actionsWithLabel"
                    />
                </div>
                <div class="kgr-postfix__fixed">
                    <button
                        id="list_edit_button"
                        type="button"
                        class="kgr-button kgr-button--accent"
                        :disabled="selectedAction === ''"
                        @click="showDialog"
                    >
                        {{ tListListActionShowDialog }}
                    </button>
                </div>
            </div>
        </label>

        <kgr-list-action-dialog
            :show="showActionDialog"
            :action="selectedAction"
            :institution-id="institutionId"
            :list-id="listId"
            :entity-ids="selectedIds"
            :entity="entity"
            @onClose="onClose"
        />
    </div>
</template>

<script>
import Dropdown from '../../common/form/select/Dropdown.vue';
import ListActionDialog from './ListActionDialog.vue'

export default {
    components: {
        'kgr-dropdown': Dropdown,
        'kgr-list-action-dialog': ListActionDialog,
    },
    props: {
        actions: {
            type: Array,
            required: true,
        },
        institutionId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true
        },
        entity: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showActionDialog: false,
            action: null,
            selectedIds: []
        };
    },
    computed: {
        selectedAction() {
            if(!this.action) {
                return '';
            }
            return this.action.value;
        },
        actionsWithLabel() {
            return this.actions.map((action) => {
                return {label: this.$t('Lists.actions.' + action.label), value: action.value};
            });
        },
        tListListActionShowDialog() {
            return this.$t('Lists.actions.showActionDialog');
        },
        tListActionSelectLabel() {
            return this.$t('Stapelverarbeitung');
        },
    },
    methods: {
        getSelectedIds() {
            this.selectedIds = $('.kgr-list-action-checkbox:checkbox:checked').map(function () {
                return $(this).data('entity-id');
            }).get();
        },
        showDialog() {
            this.getSelectedIds();
            this.showActionDialog = true;
        },
        onClose() {
            this.showActionDialog = false;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  #list-action-select {
    min-width: 200px;
  }
</style>
